export const CREATE_ACCOUNT = "CREATE_ACCOUNT";
export const SUBMITTING_ACCOUNT = "SUBMITTING_ACCOUNT";
export const SUBMIT_SUCCEEDED = "SUBMIT_SUCCEEDED";
export const CREATE_ACCOUNT_FAILED = "CREATE_ACCOUNT_FAILED";
